<div class="modal-container">
  <ion-button class="close-button" fill="clear" (click)="close()">
    <ion-icon name="close-outline"></ion-icon>
  </ion-button>
  
  <ion-datetime
    [value]="initialDate"
    [min]="minDate"
    [max]="maxDate"
    presentation="date"
    [preferWheel]="false"
    showDefaultButtons="false"
    showDefaultTitle="false"
    (ionChange)="onDateChange($event)">
  </ion-datetime>
  
  <ion-button expand="block" class="ok-button" (click)="confirm()" color="primary">
    {{ 'questionnaire-form-page.button.next' | translate }}
  </ion-button>
</div>
